import Axios from 'axios';
import { protectedResources } from '../authConfig';

const URL =
  protectedResources.apiHRMobile.baseApi +
  '/api/v1/AdvanceSalary/SetAdvanceSararyRequest';
let tokenKey;

export async function setRequestSalary(amount = 0) {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }

  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };

  const bodyParameters = {
    requestAmount: amount,
  };

  try {
    if (amount > 0) {
      const response = await Axios.post(URL, bodyParameters, config);
      return await response;
    }
  } catch (error) {
    throw new Error(error.response.data.detail);
  }
}
